import React, { Component } from 'react';
import AOS from 'aos';
import '../node_modules/aos/dist/aos.css';
import { Router, Route } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'
import ReactGA from 'react-ga';

// components
import Header from './components/header/header';
import Footer from './components/footer/footer';

// pages
import Home from './pages/home/home';
import Tech from './pages/tech/tech';
import Portfolio from './pages/portfolio/portfolio';
import Blog from './pages/blog/blog';
import Contact from './pages/contact/contact';

const PiwikReactRouter = require('piwik-react-router');
const piwik = PiwikReactRouter({
  url: 'https://stats.bitbenders.com',
  siteId: 1
});

const history = createHistory()
piwik.connectToHistory(history);

ReactGA.initialize('UA-104205019-1');
history.listen((location, action) => {
    ReactGA.pageview(location.pathname + location.search);
    console.log(location.pathname)
});

class App extends Component {

  componentDidMount() {
    AOS.init()
  }

  render() {
    return (
      <Router history={history}>
        <div className="App">
          <Header />
          <Route exact path="/" component={Home} />
          <Route path="/tech" component={Tech} />
          <Route path="/portfolio" component={Portfolio} />
          <Route path="/blog" component={Blog} />
          <Route path="/contact" component={Contact} />
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js